// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"434":"8c6c0009","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};